module.exports = __webpack_public_path__ + "static/media/triangledark.3c4d684d.png";